<template>
  <div class="wrap">
    <header><img :src="doctor" alt=""> {{$store.getters['getUIText']("drseptrissays")}}</header>
    <div id="text">{{tip.response}}</div>
    <template v-if="tip.quiz">
      <div id="quizQuestion">{{quiz.question}}</div>
      <button v-for="(a, index) in quiz.answers"
              :key="index"
              @click="processQuizanswer(index)"
              :disabled="quizResponse"
              :class="{chosen: chosenAnswer === index, correct: a.score > 0 && chosenAnswer >= 0, incorrect: a.score <= 0 && chosenAnswer >= 0}"
      >{{a.text}}</button>
      <div id="quizResponse">{{quizResponse}}</div>
    </template>
    <button @click="continueGame" v-if="!tip.quiz || quizResponse">Continue</button>
  </div>
</template>

<script>
import GameManager from "@/assets/js/GameManager";
export default {
  name: "tip",
  props: ["tip"],
  data(){
    return {
      chosenAnswer: -1,
      quizResponse: null
    }
  },
  computed: {
    doctor(){
      return this.$store.getters.getImage("./" + this.tip.image);
    },
    quiz(){
      return GameManager.patients[GameManager.selectedSlot].quizzes.find(i=>i.id===this.tip.quiz);
    }
  },
  methods: {
    continueGame(){
      if(this.tip.callback){
        this.tip.callback();
      }
      GameManager.clearTip();
    },
    processQuizanswer(answerIndex){
      // Display the response
      this.chosenAnswer = answerIndex;
      this.quizResponse = this.quiz.answers[answerIndex].response;
      GameManager.score += this.quiz.answers[answerIndex].score;
      //save the quiz response
      GameManager.patients[GameManager.selectedSlot].addQuizResponse({
        question: this.quiz.question,
        answer: this.quiz.answers[answerIndex].text,
        response: this.quizResponse,
        score: this.quiz.answers[answerIndex].score
      })
    }
  },
  mounted(){
    this.chosenAnswer = -1;
    this.quizResponse = null;
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";
.wrap{
  position: absolute;
  top: 54px;
  left: 0;
  width: 100%;
  height: calc(100% - 54px);
  background: linear-gradient(to bottom, lighten(@lightgray, 20%), @lightgray);
  overflow: auto;
  z-index: 10;
}
header{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vh 0 ;
  font-size: 3rem;
  color: @red;
  font-weight: bold;
  &:after{
    content: ' ';
    display: block;
    position: absolute;
    bottom: 0;
    height: 1vh;
    width: 100%;
    background: linear-gradient(to bottom, lighten(@red, 10%), darken(@red, 10%));
  }
}
#text, #quizQuestion, #quizResponse{
  max-width: 35em;
  margin: 3vh auto;
  padding: 0 1em;
  font-size: 1.5rem;
  line-height: 1.4;
}

button{
  display: block;
  margin: 1rem auto;
  padding: 0.5rem;
  width: 90%;
  max-width: 25em;
  font-size: 1.5rem;
  text-align: center;
  &:disabled{
    background: fade(@white, 40%)
  }
  &.chosen{
    &.incorrect{
      color: white;
      background-color: @red;
    }
  }
  &.correct{
    color: white;
    background-color: @darkgreen;
  }
}

</style>
